import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Mail, Link2, Copy, Check } from "lucide-react";

export function InviteMethod({ value, onChange, testid = "invite-method" }) {
  const opt = (key, Icon, label) => (
    <button type="button" data-testid={`${testid}-${key}`} onClick={() => onChange(key)}
      className={`flex-1 inline-flex items-center justify-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${value === key ? "bg-[#06060C] text-white" : "text-[#595D62] hover:bg-[#F6F6FD]"}`}>
      <Icon className="h-3.5 w-3.5" /> {label}
    </button>
  );
  return (
    <div className="flex items-center gap-1 rounded-full border border-[#EEEFEF] bg-white p-1" data-testid={testid}>
      {opt("email", Mail, "Send invite email")}
      {opt("link", Link2, "Copy invite link")}
    </div>
  );
}

const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); return true; } catch (e) { return false; }
};

export function InviteLinkDialog({ invite, onClose }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => { if (invite?.url) copyText(invite.url).then((ok) => ok && setCopied(true)); }, [invite?.url]);
  if (!invite) return null;
  const copy = async () => {
    if (await copyText(invite.url)) { setCopied(true); toast.success("Invite link copied"); }
    else { document.getElementById("invite-link-input")?.select(); toast.message("Press Ctrl/Cmd + C to copy"); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-md" data-testid="invite-link-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Invite link for {invite.name}</DialogTitle>
          <DialogDescription>{invite.description || "Send it personally by text, WhatsApp or your own email. It's the same link the invite email uses, and it works for 7 days."}</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input id="invite-link-input" readOnly value={invite.url} onFocus={(e) => e.target.select()} data-testid="invite-link-input" className="bg-[#F6F6FD] border-[#EEEFEF] text-xs font-mono-data" />
          <Button data-testid="invite-link-copy" onClick={copy} className="rounded-full bg-[#06060C] text-white hover:bg-[#1c1c24] shrink-0">
            {copied ? <><Check className="h-4 w-4 mr-1" /> Copied</> : <><Copy className="h-4 w-4 mr-1" /> Copy</>}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
